<template>
    <div class="manual-test-paper">
        <div class="manual-test-paper-box">
            <h3>创建试卷</h3>
            <div class="manual-test-paper-cont">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="试卷范围"  class="manual-test-scope" required>

                        <el-form-item  prop="grade"  label-width="0">
                            <el-select clearable  v-model="ruleForm.grade" placeholder="请选择年级" @change="setRange($event, 'grade')"> 
						    <el-option
						      v-for="(item, index) in gradeLsit"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
                        </el-form-item>

                        <el-form-item  prop="subject" label-width="0">
                           <el-select clearable  v-model="ruleForm.subject" placeholder="请选择科目" @change="setRange($event, 'subject')">
						    <el-option
						      v-for="(item, index) in subjectLsit"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
                        </el-form-item>

                        <el-form-item  prop="edition" label-width="0">
                          <el-select clearable  v-model="ruleForm.edition" placeholder="请选择版本" @change="setRange($event, 'edition')">
	                        		<el-option
	                        		v-for="(item, index) in editionList"
	                        		:key="index"
	                        		:label="item.name"
	                        		:value="item.id">
	                        	</el-option>
	                        </el-select>
                        </el-form-item>


	                    <el-form-item  prop="material" label-width="0">
	                    	<el-select clearable  v-model="ruleForm.material" placeholder="请选择教材">
	                        		<el-option
	                        		v-for="(item, index) in materialList"
	                        		:key="index"
	                        		:label="item.name"
	                        		:value="item.id">
	                        	</el-option>
	                        </el-select>
	                    </el-form-item>
                    </el-form-item>


                    <el-form-item label="试卷名称" prop="name" class="manual-test-paper-name">
                       <el-input v-model="ruleForm.name" placeholder="输入试卷名称，不超过20字" maxlength="20"></el-input>
                    </el-form-item>
					
					<el-form-item label="试题类型" prop="type">
					    <el-radio-group v-model="ruleForm.type">
					        <template v-for="item of getTestTypeList">
						  		<el-radio :label="item.id">{{item.name}}</el-radio>
						  	</template>
					    </el-radio-group>
					</el-form-item>

					<el-form-item label="建议时长" prop="duration" class="duration">
					    <el-input-number v-model="ruleForm.duration" controls-position="right"  :min="1" :max="500"></el-input-number><span>分钟</span>
					</el-form-item>

					<el-form-item label="组卷形式" prop="shape">
					    <el-radio-group v-model="ruleForm.shape">
					        <el-radio label="1">章节组卷</el-radio>
					        <el-radio label="2">知识点组卷</el-radio>
					    </el-radio-group>
					</el-form-item>

                    <el-form-item  label-width="0">
                        <el-button type="primary" @click="submitForm('ruleForm')" v-preventReClick>开始组卷</el-button>
                        <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
	    data() {
	        return {
	            ruleForm: {
	            	grade: '', 		/*年级id*/
	            	subject: '',    /*科目id*/
	            	edition: '', 	/*版本id*/
	            	material: '',	/*教材*/
	            	name: '',      /*试卷名称*/
	            	type: '',		/*试题类型*/
	            	duration: 100,	/*建议时长*/
	            	shape: '',		/*组卷形式*/
	            },
	            gradeLsit: [], 		/*年级列表*/
	            subjectLsit: [], 	/*科目列表*/
	            editionList: [], 	/*版本列表*/
	            materialList: [],	/*教材*/
	            getTestTypeList: [],
	            rules: {
	            	grade: [
	            	    { required: true, message: '请选择年级', trigger: 'change' }
	            	],
	            	subject: [
	                    { required: true, message: '请选择科目', trigger: 'change' }
	                ],
	                edition: [
	                    { required: true, message: '请选择版本', trigger: 'change' }
	                ],
	                 material: [
	                    { required: true, message: '请选择版本', trigger: 'change' }
	                ],
	                name: [
	                    { required: true, message: '请输入试卷名称', trigger: 'blur' },
	                    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
	                ],
	                type: [
	                    { required: true, message: '请选试题类型', trigger: 'change' }
	                ],
	                duration: [
	                    {  required: true, message: '请输入建议时长', trigger: 'change' }
	                ],
	                shape: [
	                    {  required: true, message: '请选组卷形式', trigger: 'change' }
	                ],
	            }
	        };
	    },
	    created(){
	    	this.getGrade()
	    	this.getTestType()
	    },
	   
	     methods: {
	    	/**
	    	 * 请求年级列表数据
	    	 * @DateTime 2019-07-22T14:45:06+0800
	    	 */
	    	getGrade(){
	    		let success = (res=>{
	    			this.gradeLsit = res.data;
	    		});

	    		let params = {
	    			level:3,
	    			// pid:0,
	    			direction:'balance',
	    		};

	    		this.$ajax({
	    			url: 'api/org/org',
	    			method: 'get',
	    			params: params,
	    			func: { success: success}
	    		})
	    	},
	    	/**
	    	 * 请求科目数据
	    	 * @DateTime 2019-07-22T14:53:30+0800
	    	 */
	    	getSubject(){
	    		let success = (res=>{
	    			this.subjectLsit = res.data
	    		});

	    		let params = {
	    			type:2,
	    			org_id: this.ruleForm.grade,
	    			status:1,
	    		};

	    		this.$ajax({
	    			url: 'api/cate/subject',
	    			method: 'get',
	    			params: params,
	    			func: {success: success}
	    		})
	    	},
	    	/**
	    	 * 请求科目版本
	    	 * @DateTime 2019-07-22T15:30:28+0800
	    	 */
	    	getEdition(){
	    		let success = (res=>{
	    			this.editionList = res.data;
	    		});

	    		let params = {
	    			type:2,
	    			org_id:this.ruleForm.grade,
	    			sub_id:this.ruleForm.subject,
	    			status:1
	    		};

	    		this.$ajax({
	    			url: 'api/cate/version',
	    			methosd: 'get',
	    			params: params,
	    			func: {success: success}
	    		})
	    	},
	    	/**
	    	 * 请求教材列表数据
	    	 * @DateTime 2019-07-22T15:39:04+0800
	    	 * @return   {[type]}                 [description]
	    	 */
	    	getMaterial(){
	    		let success = (res=>{
	    			this.materialList = res.data;
	    		});

	    		let params = {
	    			org_id:this.ruleForm.grade,
	    			sub_id:this.ruleForm.subject,
	    			ver_id:this.ruleForm.edition,
	    			status:1
	    		};

	    		this.$ajax({
	    			url: 'api/cate/material',
	    			method: 'get',
	    			params: params,
	    			func: {success: success}
	    		})
	    	},
	    	/**
	    	 * 改变题目范围
	    	 * @param {String} type
	    	 * 根据改变当前参数重置相关数据
	    	 */
	    	setRange(val, type){
	    		switch( type ){
	    			case 'grade': /*年级*/
	    				this.ruleForm.subject = '';
	    				this.ruleForm.edition = '';
	    				this.ruleForm.material = '';

	    				this.subjectLsit = [];
	    				this.editionList = [];
	    				this.materialList = [];
	    				this.getSubject();
	    			break;
	    			case 'subject': /*科目*/
	    				this.ruleForm.edition = '';
	    				this.ruleForm.material = '';

	    				this.editionList = [];
	    				this.materialList = [];
	    				this.getEdition();
	    			break;
	    			case 'edition': /*版本*/
	    				this.ruleForm.material = '';
	    				this.materialList = [];
	    				this.getMaterial();
	    			break;
	    		}
	    	},
	    	/**
	    	 * 请求试题类型数据
	    	 * @DateTime 2019-07-25T14:09:13+0800
	    	 * @return   {[type]}                 [description]
	    	 */
	    	getTestType(){

	    		let success = (res=>{
	    			this.getTestTypeList = res.data;
	    			// if (this.getTestTypeList.length > 0) {
	    			// 	this.getTestTypeList.unshift({id:0, name: '全部'})
	    			// }
	    		});

	    		let params = {status: 1};

	    		this.$ajax({
	    			url: 'api/newtest/get_test_type',
	    			method: 'get',
	    			params: params,
	    			func: { success: success}
	    		})
	    	},
	        submitForm(formName) {
	        	
	            this.$refs[formName].validate((valid) => {
	                if (valid) {
	                	let success = (res =>{
	                		this.$message.success(res.msg);
	                		// sessionStorage.setItem('addTS', true)
	                		// sessionStorage.setItem('manualObj', JSON.stringify(this.ruleForm))
	                		this.$router.push({path: '/test/knowledge-points', query: {id: res.data, points: 1 ,auth_type: this.ruleForm.shape}})
	                	});

	                	let params = {
	                		create_id: this.$g.user_id,
	                		name: 			this.ruleForm.name,
	                		grade_id:  		this.ruleForm.grade,
	                		subject_id:  	this.ruleForm.subject,
	                		version_id:  	this.ruleForm.edition,
	                		course_id: 		this.ruleForm.material,
	                		source_id: 		this.ruleForm.type,
	                		answer_time: 	this.ruleForm.duration,
	                		auth_type: 		this.ruleForm.shape,
	                		authority: 0,
	                		status: 0,
	                	};

	                	this.$ajax.post('api/newtest/add_test', params, {func: {success: success}});
	                /*	this.$ajax({
	                		url: 'api/newtest/add_test',
	                		method: 'post',
	                		params: params,
	                		func: {success: success}
	                	})*/
	                } else {
	                    console.log('error submit!!');
	                    return false;
	                }
	            });
	        },
	        resetForm(formName) {
	            this.$refs[formName].resetFields();
	        }
	    }
	}
</script>

